import React, { useEffect, useState } from 'react';
import { Leaf } from 'lucide-react';
export function OfferBar() {
  // Start countdown from 23h 47m 12s
  const [timeLeft, setTimeLeft] = useState(23 * 3600 + 47 * 60 + 12);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <div className="fixed top-0 left-0 w-full z-[1000] bg-gradient-to-r from-[#1B4332] via-[#2D5A3D] to-[#1B4332] text-[#FEFCF6] text-center py-2.5 px-4 text-xs md:text-sm font-medium shadow-lg border-b border-[#4A8C5C]/30 flex justify-center items-center gap-2" data-id="element-310">
      <div className="flex items-center gap-2 animate-pulse-green" data-id="element-311">
        <Leaf className="w-4 h-4 text-[#C17817]" fill="#C17817" data-id="element-312" />
        <span className="tracking-wide font-bold" data-id="element-313">
          🔥 OFERTA ESPECIAL TERMINA EN:{' '}
          <span className="font-mono text-[#FEFCF6]" data-id="element-314">{formattedTime}</span>
        </span>
      </div>
      <span className="hidden md:inline text-[#F0F4EC]/80 mx-2" data-id="element-315">|</span>
      <span className="hidden md:inline font-semibold text-[#F0F4EC]" data-id="element-316">
        80% DE DESCUENTO + 2 REGALOS GRATIS — SOLO HOY
      </span>
    </div>;
}